import { formatAnalyticsValue } from '@blueshift-ui/telemetry';

// Exports
// -------

export default function addVtSource(path, placement) {
  const segments = path.split('#');
  const hash = segments[1] ? `#${segments[1]}` : '';
  const source = `learn-lab${placement ? `-${formatAnalyticsValue(placement)}` : ''}`;
  return `${segments[0]}${segments[0].includes('?') ? '&' : '?'}vtsource=${source}${hash}`;
}
